import { render, staticRenderFns } from "./WindowLayout.vue?vue&type=template&id=18c0c43f&scoped=true"
import script from "./WindowLayout.vue?vue&type=script&lang=js"
export * from "./WindowLayout.vue?vue&type=script&lang=js"
import style0 from "./WindowLayout.vue?vue&type=style&index=0&id=18c0c43f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c0c43f",
  null
  
)

export default component.exports